// organize-imports-ignore
import ReactDOM from "react-dom/client";
import "@shared/utilities/global-polyfill";
import "regenerator-runtime";
import "./index.css";
import AppContext from "./components/AppContext";
import App from "./App";

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <AppContext>
    <App />
  </AppContext>,
);
